import { render, staticRenderFns } from "./AddTeam.vue?vue&type=template&id=1dc4e43e&scoped=true"
import script from "../js/components/AddTeam.js?vue&type=script&lang=js&external"
export * from "../js/components/AddTeam.js?vue&type=script&lang=js&external"
import style0 from "./AddTeam.vue?vue&type=style&index=0&id=1dc4e43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc4e43e",
  null
  
)

export default component.exports